import { createContext } from 'react';

export const AppContext = createContext({
  appInfo: { appId: null, accessKey: null },
});

export function getDefaultContext() {
  return { appInfo: { appId: null, accessKey: null } };
}
